import { Loss } from "../../models/types";
import { TableColumn } from "../../models/table-types";
import { datetimeParse } from "../../hooks/formats";
import { Button, Tag } from "@wfp/ui";
import { iconDeleteGlyph } from "@wfp/icons";

/**
 * Column configuration for Loss table
 */
export const createLossColumns = (
  onDelete: (loss: Loss) => void,
  t: (key: string) => string
): TableColumn<Loss>[] => [
  {
    key: "created_on",
    headerKey: "created_on",
    sortField: "created_on",
    sortable: true,
    render: (item) => datetimeParse(item.createdOn),
  },
  {
    key: "school",
    headerKey: "school",
    sortField: "school_name",
    sortable: true,
    render: (item) => item.schoolName,
  },
  {
    key: "partner",
    headerKey: "partner",
    sortField: "partner_name",
    sortable: true,
    render: (item) => item.partnerName,
  },
  {
    key: "order_number",
    headerKey: "order_number",
    sortField: "order_number",
    sortable: true,
    render: (item) => item.orderNumber,
  },
  {
    key: "item",
    headerKey: "item",
    sortField: "content_name",
    sortable: true,
    render: (item) => item.contentName,
  },
  {
    key: "category",
    headerKey: "category",
    sortField: "category_name",
    sortable: true,
    render: (item) => item.categoryName,
  },
  {
    key: "quantity",
    headerKey: "quantity",
    sortField: "quantity",
    sortable: true,
    render: (item) => item.quantity,
  },
  {
    key: "author",
    headerKey: "author",
    sortField: "author_name",
    sortable: true,
    render: (item) => item.authorName,
  },
  {
    key: "actions",
    headerKey: "actions",
    sortable: false,
    render: (item) => {
      if (item.isDiscarded) {
        return (
          <Tag
            type="info"
          >
            {t("discarded")}
          </Tag>
        );
      }
      return (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item);
          }}
          small
          kind="danger"
        >
          {t("discard")}
        </Button>
      );
    },
  },
];
